/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screens_BackInputs */

const en_onboarding_screens_back = /** @type {(inputs: Onboarding_Screens_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hurts my back`)
};

const es_onboarding_screens_back = /** @type {(inputs: Onboarding_Screens_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me duele la espalda`)
};

/**
* | output |
* | --- |
* | "Hurts my back" |
*
* @param {Onboarding_Screens_BackInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_screens_back = /** @type {((inputs?: Onboarding_Screens_BackInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screens_BackInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_screens_back(inputs)
	return en_onboarding_screens_back(inputs)
});